export const environment = {
  production: false,
  securedRoutes: ['https://signalmgmt-dev-as.azurewebsites.net'],
  apiUrl: 'https://signalmgmt-dev-as.azurewebsites.net/api/v1',
  azTenant: '8619c67c-945a-48ae-8e77-35b1b71c9b98',
  azBEClientId: '190a8292-2c72-402c-abb2-500f8b72098e',
  defaultLanguage: 'en',
};